<div class="filter-control">
  <fsx-select
    label="Court"
    [control]="formControl"
    [options]="courtOptions">
  </fsx-select>
</div>